import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const useQueryParamsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
    const updateQueryParams = (params) => {
        setSearchParams(params);
    };
    return { searchParams, page, updateQueryParams, setPage };
};

export default useQueryParamsPage;
